// removed by extract-text-webpack-plugin
module.exports = {"mainContainer":"A5iSTruxRp8chHPgb4-qQ","firstDownCard":"I2_KIKfqe86MadJCA-HFU","gameTitleBanner":"_1SSjctdagc1-8zgJyDMgBr","expandCollapseButton":"_3yspncD8wQDQe6oU5dN67f","noMoreBetsOverlay":"_2yWBfMNhqJ2QXvBYyV4hop","noMoreBetsText":"_3VSgxoGuvfI2s8Ty9KvM83","teamNameIconImage":"_3nFx0Wemd5DF_sHapGauam","teamHelmetIconImage":"_3CrhwHGMBpF7gIl6aBSyEL","vsText":"_1H9QfKe5yXiwL_uopbOR1_","meetingName":"_3aoGCq7J9DSoj2ud9QFX1Y","titleCollapseButtonContainer":"_2uYw0CGfP1Ar71D8hpovhW"};


//////////////////
// WEBPACK FOOTER
// ./src/ui-modules/sports-book/modules/firstDown/css/firstDownCard.css
// module id = 844
// module chunks = 0